// extracted by mini-css-extract-plugin
module.exports = {"timeSelect":"_2B_4L","skills":"_3gipU","overdue":"_1vWKJ","selectDescription":"T_6lc"};